<template>
  <div class="content animated fadeIn">
		<div class="top">
			<div class="top-row">
				<img src="../assets/images/back.png"
					alt=""
					@click="backPrev"/>
				<div>个人中心</div>
			</div>
      
      <!-- <img class="bg" src="../assets/images/my-bg.png" alt=""> -->
		</div>
    <div class="info-detail-wrap">
      <div class="info-detail">
        <div class="avata-info">
          <img v-if="!imgError"
              :src="`${avatarUrl}/facePhoto/getFacePhotoById?memberId=${memberInfo.memberIdAesEncrypt}`"
              alt=""
              @error="handleError">
          <img v-else
            :src="errorImg"
            alt="">
          <div class="name">{{memberInfo.memberNickname}}</div>
        </div>
        <div class="info-list-wrap">
          <ul class="info-list" v-if="role=='teacher'">
            <li class="info-list-item">
              <span>职工号</span>
              <span>{{personInfo.staffNumber}}</span>
            </li>
            <li>
              <span>姓名</span>
              <span>{{personInfo.staffName}}</span>
            </li>
            <li>
              <span>性别</span>
              <span>{{personInfo.staffSex=='1'?'男':personInfo.memberSex=='2'?'女':''}}</span>
            </li>
            <li>
              <span>民族</span>
              <span>{{personInfo.staffNational}}</span>
            </li>
            <li>
              <span>所在单位</span>
              <span>{{personInfo.staffBelongUnit}}</span>
            </li>
            <li>
              <span>级别</span>
              <span>{{personInfo.staffTechnicalTitlesLevel}}</span>
            </li>
            <li>
              <span>当前状态</span>
              <span>{{personInfo.staffCurrentState}}</span>
            </li>
            <li>
              <span>出生日期</span>
              <span>{{personInfo.staffBirthday}}</span>
            </li>
            <li>
              <span>邮箱</span>
              <span>{{personInfo.staffMail}}</span>
            </li>
            <li>
              <span>手机号</span>
              <span>{{personInfo.staffCellphoneNumber}}</span>
            </li>
            <li>
              <span>政治面貌</span>
              <span>{{personInfo.staffPoliticalStatus}}</span>
            </li>
            <li>
              <span>岗位状态</span>
              <span>{{personInfo.staffPostState}}</span>
            </li>
            <li>
              <span>工作年份</span>
              <span>{{personInfo.staffWorkingYears}}</span>
            </li>
            <li>
              <span>最高学位</span>
              <span>{{personInfo.staffAcademicDegree}}</span>
            </li>
            <li>
              <span>最高学历</span>
              <span>{{personInfo.staffAcademicQualifications}}</span>
            </li>
          </ul>
          <ul class="info-list" v-else>
            <li class="info-list-item">
              <span>学/工号</span>
              <span>{{personInfo.memberId}}</span>
            </li>
            <li>
              <span>姓名</span>
              <span>{{personInfo.memberNickname}}</span>
            </li>
            <li>
              <span>性别</span>
              <span>{{personInfo.memberSex=='1'?'男':personInfo.memberSex=='2'?'女':''}}</span>
            </li>
            <li>
              <span>民族</span>
              <span>{{personInfo.memberOtherNation}}</span>
            </li>
            <li>
              <span>院系</span>
              <span>{{personInfo.memberOtherDepartment}}</span>
            </li>
            <li>
              <span>专业</span>
              <span>{{personInfo.memberOtherMajor}}</span>
            </li>
            <li>
              <span>年级</span>
              <span>{{personInfo.memberOtherGrade}}</span>
            </li>
            <li>
              <span>班级</span>
              <span>{{personInfo.memberOtherClass}}</span>
            </li>
            <li>
              <span>生日</span>
              <span>{{personInfo.memberOtherBirthday}}</span>
            </li>
            <li>
              <span>籍贯</span>
              <span>{{personInfo.memberOtherNative}}</span>
            </li>
            <li>
              <span>手机号</span>
              <span>{{personInfo.memberPhone}}</span>
            </li>
          </ul>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["memberInfo", "roleList"]),
  },
  data() {
    return {
      // 获取头像基础路径
      avatarUrl:'',
      // 头像获取失败状态
      imgError:false,
      // 头像获取失败时的默认图片
      errorImg:'',
      // 个人信息
      personInfo:{},
      role:''
    };
  },
  mounted() {
    this.avatarUrl=avatarUrl
    if (this.memberInfo.memberSex == 2) {
      this.errorImg = require("../assets/images/woman.png");
    } else {
      this.errorImg = require("../assets/images/man.png");
    }
    this.role=sessionStorage.getItem('role')
    this.getPersonInfo()
  },
  methods: {
    /**
     * @name handleError
     * @description 头像获取失败时使用默认图片
     * @param {}
     * @author hll
     * @date 2021-05-27 16:03:20
     */
    handleError() {
      this.imgError = true;
    },
    /**
     * @name backPrev
     * @description 返回上一页
     * @param {}
     * @author hll
     * @date 2021-05-27 16:02:43
     */
    backPrev() {
      this.$router.go(-1);
    },
    /**
     * @name getPersonInfo
     * @description 获取个人信息
     * @param {}
     * @author hll
     * @date 2021-06-01 11:22:58
     */
    getPersonInfo(){
      let url=''
      if(sessionStorage.getItem('role')=='teacher'){
        url=wyyUrl+'/api/v1/index/getStaffByStaffNumber?staffNumber='+this.memberInfo.memberIdAesEncrypt
      }else if(sessionStorage.getItem('role')=='student'){
        url=emailUrl+'/app/casMember/getMemberByUsername'
      }
      this.$axios({
        method: "post",
        url: url,
      })
        .then(async (res) => {
          if (res.success) {
            if(this.role=='teacher'){
              this.personInfo=res.obj
            }else{
              this.personInfo=res.attributes.modules
            }
          }
        })
        .catch((error) => {});
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  font-size: 0.28rem;
  background: #FAFBFF;
}

.top {
  width: 100%;
  box-sizing: border-box;
  height: 1.4rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top:.3rem;
  position: relative;
  background:#0076FF;
  // img.bg{
  //   width:100%;
  //   height: 5.88rem;
  //   position: absolute;
  //   top:0;
  //   left:0;
  //   z-index:-1;
  // }
}
.top-row{
    position: relative;
    width:100%;
    height: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .36rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.top-row img {
  position: absolute;
  width: 0.22rem;
  height: 0.36rem;
  left: 0.23rem;
  top: 0.41rem;
  display: inline-block;
}
.info-detail-wrap{
  width:100%;
  height: calc(100% - 1.4rem);
}
.info-detail{
  height: 100%;
  overflow-y: auto;
  .avata-info{
    padding-top:.3rem;
    width:100%;
    height: 3rem;
    box-sizing: border-box;
    text-align: center;
    color:#fff;
    background:#0076FF;
    img{
      width:1.53rem;
      height: 1.53rem;
      margin-bottom:.2rem;
      border-radius: 50%;
    }
  }
  .info-list-wrap{
      width:100%;
      height: calc(100% - 3rem);
      background:#EDEDED;
      padding-top:.16rem;
      box-sizing: border-box;
      .info-list{
        max-height:100%;
        background-color:#fff;
        li{
          width:100%;
          height: .7rem;
          display: flex;
          align-items: center;
          padding-left:.3rem;
          border-bottom:1px solid #eee;
          span:first-child{
            display: inline-block;
            width:1.4rem;
            text-align: right;
            color:#666;
            margin-right: .3rem;
          }
        }
      }
  }
}
.info-detail::-webkit-scrollbar{
    display: none!important;
    width: 0px;  
    height: 0px;
}
</style>